/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import GoogleMapReact from 'google-map-react';
import config from '../configuration';
import RatingDot from '../components/misc/RatingDot';
import MapFilter from '../components/menus/MapFilter';
import ClinicProfile from '../components/clinics/ClinicProfile';
import DepartmentProfile from '../components/clinics/DepartmentProfile';
import DomainData from '../assets/datasets/DomainData';
import LongFMLogo from '../assets/img/logo_lang.png';
import { isInViewport, viewPortToMinMax } from '../functions/LocationFunctions';
import queryString from 'qs';
import axios from 'axios';
import CheckField from '../components/forms/CheckField';
import { AppInfoContext } from '../components/context/AppInfo';
import { TrackingContext } from '../components/context/Tracking';
import MiniWindow from '../components/misc/MiniWindow';
import { WindowManagerContext } from '../components/context/WindowManager';
import PrimaryButton from '../components/buttons/PrimaryButton';
import { AuthContext } from '../components/context/Auth';

const DEFAULT_ZOOM = 6;
const DEFAULT_CENTER = { lat: 52, lng: 10.3 };
const CLINIC_ZOOM = 12;
const CITY_ZOOM = 12;

/* const testClinics = [...Array(2000)].map((_, i) => {
  const id = i;
  const lng = 7 + Math.random() * 6;
  const lat = 48 + Math.random() * 5;
  const rated = Math.random() > 0.5;
  const name = 'Klinik ' + ['am', 'auf dem', 'im', 'neben dem', 'an dem'][Math.floor(Math.random() * 5)] + ' ' + ['Rhein', 'Donau', 'Elbe', 'Weser', 'Pader'][Math.floor(Math.random() * 5)];
  const departments = [...Array(Math.floor(Math.random() * 15))].map((_, i) => DomainData.areasOfExpertise[Math.floor(Math.random() * DomainData.areasOfExpertise.length)].value);
  return { id, rated, location: { lat, lng }, departments: departments.map((d, di) => ({ name: d, id: di * 1000 * i })), departmentNames: departments, name };
}); */

const ClinicMap = props => {
  const [zoom, setZoom] = React.useState(DEFAULT_ZOOM);
  const [center, setCenter] = React.useState(DEFAULT_CENTER);
  const [zoomTo, setZoomTo] = React.useState(null);
  // const [mapInstance, setMapInstance] = React.useState(null);
  // const [mapInstance.api, setMapApi] = React.useState(null);
  const [oldViewport, setOldViewport] = React.useState(null);
  const [profileOpen, setProfileOpen] = React.useState(false);
  const [waitForProfileOpen, setWaitForProfileOpen] = React.useState(null);
  const [forceFilterOpen, setForceFilterOpen] = React.useState(null);
  const [subjectAreaFilterPromptOpen, setSubjectAreaFilterPromptOpen] = React.useState(null);
  const [subjectAreaFilterText, setSubjectAreaFilterText] = React.useState('');
  const [wizardTextOpen, setWizardTextOpen] = React.useState(false);
  const [wizardExpanded, setWizardExpanded] = React.useState(false);
  const [mapFilterKey, setMapFilterKey] = React.useState(1);
  const [clinics, setClinics] = React.useState([]);
  const [filter, setFilter] = React.useState({
    rated: true,
    departments: [],
    lat_min: 0,
    lat_max: 1000,
    lng_min: 0,
    lng_max: 1000
  });

  const { mapInstance, setMapInstance, isMobile } = React.useContext(AppInfoContext);
  const { user } = React.useContext(AuthContext);
  const { t } = React.useContext(TrackingContext);
  const { openWindow, windows, closeWindow } = React.useContext(WindowManagerContext);

  const [chosenClinic, setChosenClinic] = React.useState(null);
  const [chosenDepartment, setChosenDepartment] = React.useState(null);

  const changeViewport = viewport => setFilter(old => ({ ...old, ...viewPortToMinMax(viewport) }));

  const getClinics = (filter) => {
    const query = queryString.stringify(filter);
    axios.get(config.backendAddress + '/open/getClinics?' + query)
      .then(result => {
        setClinics(old => result.data);
      })
      .catch(err => console.log(err));
  };

  const apiHasLoaded = (map, maps) => {
    setMapInstance({ map, api: maps });
    // setMapApi(maps);
  };

  React.useEffect(() => {
    if (props.params.gotoClinic && mapInstance?.api) {
      // openClinic(props.params.gotoClinic);
    }
    if (props.params.goto && mapInstance?.api) {
      // openClinic(props.params.gotoClinic);
      if (props.params.goto === 'makeRating') {
        closeWindow('preFilter');
        openWindow('createRating');
        props.setParams({});
      }
    }
  }, [props.params, mapInstance?.api]);

  React.useEffect(() => {
    if (mapInstance) {
      openWindow('preFilter', {
        setCenterAndZoomIn: (x, y) => {
          if (!subjectAreaFilterPromptOpen) setSubjectAreaFilterPromptOpen(true);
          setCenterAndZoomIn(x, y);
          setMapFilterKey(old => old + 1);
        },
        mapInstance: mapInstance.map,
        mapApi: mapInstance.api,
        onClose: () => setMapFilterKey(old => old + 1)
      });
    }
  }, [mapInstance]);

  React.useEffect(() => {
    if (!zoomTo && !center.zoom) {
      /* const isInOldViewport = oldViewport ? isInViewport(center, oldViewport) : false;
      if (!isInOldViewport)  */
      getClinics(filter);
    }
    /* const { lat_min = 0, lat_max = 1000, lng_min = 0, lng_max = 1000 } = filter;
    const viewportBase = { lat_min, lat_max, lng_min, lng_max };
    setClinics(old => {
      let filteredClinics = [...testClinics];
      filteredClinics = filteredClinics.filter(c => isInViewport(c.location, viewportBase));
      if (filter.departments.length > 0) {
        filteredClinics = filteredClinics.filter(c => {
          return filter.departments.filter(fd => c.departmentNames.includes(fd)).length > 0;
        })
        ;
      }
      if (filter.rated) filteredClinics.filter(c => c.rated);
      return filteredClinics;
    }); */
    const { lat_min = 0, lat_max = 1000, lng_min = 0, lng_max = 1000 } = filter;
    const viewportBase = { lat_min, lat_max, lng_min, lng_max };
    setOldViewport(viewportBase);
  }, [filter, zoomTo]);

  React.useEffect(() => {
    if (filter.departments.length > 0) {
      t('action', 'filter_departments', filter.departments.join(','));
      setSubjectAreaFilterPromptOpen(false);
    }
  }, [filter.departments]);

  React.useEffect(() => {
    console.log(user);
    if (user?.email) setWizardTextOpen(true);
  }, [user]);

  const gotoNewCenter = (desiredCenter, zoom) => {
    if (zoom < (CLINIC_ZOOM - 3)) {
      setWaitForProfileOpen(true);
      setCenterAndZoomIn(desiredCenter, 12);
    } else {
      setCenter(desiredCenter);
      setProfileOpen(true);
    }
  };

  const openDepartment = (clinicId = null, departmentId = null, open = true) => {
    if (open) t('action', 'open_department', departmentId);
    console.log('opens department', clinicId, departmentId);
    if (open) {
      const clinic = clinics.find(c => c.id === clinicId);
      if (!clinic) return;
      const desiredCenter = { lat: clinic.lat, lng: clinic.lng };
      // const departmentIdx = clinic.department_ids.findIndex(d => d === departmentId);
      gotoNewCenter(desiredCenter, zoom);
      // setChosenDepartment({ id: clinic.department_ids[departmentIdx] || departmentId, name: clinic.departments[departmentIdx] });
      setChosenDepartment({ id: departmentId });
      setChosenClinic(clinic);
    } else {
      setChosenDepartment(null);
      setProfileOpen(false);
    }
  };

  const openClinic = (clinicId = null, open = true) => {
    if (open) t('action', 'open_clinic', clinicId);
    console.log('opens clinic', clinicId);
    const newChosenClinic = clinics.find(c => c.id === clinicId);
    if (open) {
      setChosenDepartment(null);
      const desiredCenter = { lat: newChosenClinic.lat, lng: newChosenClinic.lng };
      gotoNewCenter(desiredCenter, zoom);
      setChosenClinic(newChosenClinic);
    } else {
      setChosenClinic(null);
      setProfileOpen(false);
    }
  };

  function slowlyZoom (current, goal, setZoom, endFunction = () => {}) {
    const newEndFunction = () => {
      endFunction();
      /* if (waitForProfileOpen) {
        console.log('must be true: ', waitForProfileOpen);
        setProfileOpen(true);
      } */
    };
    return setTimeout(() => {
      const newCurrent = goal > current ? current + 1 : current - 1;
      setZoom(newCurrent);
      if (goal !== newCurrent) {
        slowlyZoom(newCurrent, goal, setZoom, newEndFunction);
      } else {
        endFunction();
      }
    }, 80);
  }

  React.useEffect(() => {
    if (zoomTo) {
      // setCenter(old => ({ lat: center.lat, lng: center.lng }));
      const zoomTimer = slowlyZoom(zoom, zoomTo, setZoom, () => {
        setTimeout(() => {
          setZoomTo(null);
          setProfileOpen(true);
        }, 400);
      });
      return () => {
        clearTimeout(zoomTimer);
      };
    }
  }, [zoomTo]);

  /* React.useEffect(() => {
    if (profileOpen) {
      setWaitForProfileOpen(false);
    }
  }, [profileOpen]); */

  const setCenterAndZoomIn = (center, zoomFactor) => {
    setClinics([]);
    setCenter({ ...center/* , zoom: zoomFactor */ });
    setZoomTo(zoomFactor);
  };

  const zoomToCity = () => {
    setZoom(12);
  };

  // filteredClinics = testClinics.filter();

  return (
    <div style={{ height: window.innerHeight /* '100vh' */, width: '100%', overflow: 'hidden' }}>
      {
        (mapInstance?.api?.places && mapInstance?.map && filter) && (
          <MapFilter
            openWizard={() => openWindow('wizard', {
              mapInstance: mapInstance.map,
              mapApi: mapInstance.api,
              onClose: () => setMapFilterKey(old => old + 1)
            })}
            key={'map_filter_' + mapFilterKey}
            mapInstance={mapInstance.map}
            mapApi={mapInstance.api}
            setCenter={setCenter}
            setZoom={zoomToCity}
            setCenterAndZoomIn={(x, y) => {
              if (!subjectAreaFilterPromptOpen) {
                setSubjectAreaFilterPromptOpen(old => true);
                if (filter.departments.length > 0) setSubjectAreaFilterText('Du filterst gerade nach ' + filter.departments.join('und'));
              }
              setCenterAndZoomIn(x, y);
            }}
            filter={filter}
            forceFilterOpen={forceFilterOpen}
            setForceFilterOpen={setForceFilterOpen}
            setFilter={(key, value) => {
              if (key === 'departments' && value.length === 1) setFilter(old => ({ ...old, [key]: value, rated: false }));
              else setFilter(old => ({ ...old, [key]: value }));
            }}
          />
        )
      }
      <GoogleMapReact
        bootstrapURLKeys={process.env.NODE_ENV === 'asd'
          ? {}
          : {
              key: config.serviceCredentials.mapsKey,
              language: 'de',
              region: 'de',
              libraries: ['places']
            }}
        defaultCenter={DEFAULT_CENTER}
        defaultZoom={DEFAULT_ZOOM}
        onDragEnd={(c) => {
          const ne = c.getBounds().getNorthEast();
          const sw = c.getBounds().getSouthWest();
          changeViewport({ ne: { lat: ne.lat(), lng: ne.lng() }, sw: { lat: sw.lat(), lng: sw.lng() } });
          setCenter({ lat: c.center.lat(), lng: c.center.lng() });
        }}
        onZoomAnimationEnd={(z) => {
          const ne = mapInstance.map?.getBounds().getNorthEast();
          const sw = mapInstance.map?.getBounds().getSouthWest();
          changeViewport({ ne: { lat: ne?.lat() || 1000, lng: ne?.lng() || 1000 }, sw: { lat: sw?.lat() || 0, lng: sw?.lng() || 0 } });
          setZoom(z);
        }}
        zoom={zoom}
        center={center}
        onGoogleApiLoaded={(api) => { apiHasLoaded(api.map, api.maps); }}
        style={{
          zIndex: 100
        }}
        options={{
          disableDefaultUI: true
        }}
      >
        {
        !zoomTo && clinics.map((clinic, i) => {
          let { lat, lng, rating_count: ratingCount, positive_ratings: positiveRatings, negative_ratings: negativeRatings, medium_ratings: mediumRatings } = clinic;

          ratingCount = ratingCount || (positiveRatings || 0) + (negativeRatings || 0) + (mediumRatings || 0);

          if (filter.departments.length > 0 && filter.rated && clinic.ratings) {
            let rated = false;
            for (let i = 0; i < clinic.departments.length; i++) {
              if (filter.departments.includes(clinic.departments[i]) && clinic.ratings[i]) {
                rated = true;
              }
            }
            if (!rated) return null;
          }
          return (
            <div
              key={i}
              lat={lat}
              lng={lng}
              text=''
            >
              <RatingDot
                onClick={() => {
                  if (filter.departments.length === 1 && filter.departments[0] !== 'Innere Medizin') {
                    /* const departmentIdx = clinic.departments.findIndex(d => d === filter.departments[0]);
                    const departmentId = clinic.department_ids[departmentIdx];
                    const departmentParentId = clinic.parent_ids[departmentIdx];
                    console.log(departmentId); */
                    console.log(clinic);
                    if (zoom <= 8) { setCenterAndZoomIn({ lng: clinic.lng, lat: clinic.lat }, CITY_ZOOM); return; }
                    // openDepartment(clinic.id, departmentParentId || departmentId);
                    openDepartment(clinic.id, clinic.department_id[0]);
                    setChosenClinic(clinic);
                  } else {
                    if (zoom <= 8) { setCenterAndZoomIn({ lng: clinic.lng, lat: clinic.lat }, CITY_ZOOM); return; }
                    openClinic(clinic.id);
                  }
                }}
                ratings={{ p: 0, m: 0, n: ratingCount }}
                noColor
                big={zoom > 8 || (filter.departments.length > 0 && filter.rated === true)}
                highlighted={clinic.status === 1}
              />
            </div>
          );
        })
        }
      </GoogleMapReact>
      {
        (profileOpen && chosenClinic && !chosenDepartment) && (
          <ClinicProfile
            key={chosenClinic.id}
            openDepartment={(id, open = true) => openDepartment(chosenClinic.id, id, open)}
            open={(open) => openClinic(chosenClinic.id, open)}
            clinicObject={chosenClinic}
            departmentFilter={filter.departments}
          />
        )
      }
      {
        (profileOpen && chosenDepartment) && (
          <DepartmentProfile
            key={chosenDepartment.id}
            department={chosenDepartment}
            clinic={chosenClinic}
            open={(open = true) => setProfileOpen(open)}
            openClinic={() => openClinic(chosenClinic.id)}
            onlyOneSubjectArea={filter.departments.length === 1}
          />
        )
      }
      <MiniWindow
        cta={() => setForceFilterOpen(true)}
        ctaText='Filtern'
        open={!wizardTextOpen && subjectAreaFilterPromptOpen}
        setOpen={setSubjectAreaFilterPromptOpen}
      >
        {subjectAreaFilterText || 'Willst du nach Fachbereichen filtern?'}
      </MiniWindow>
      <MiniWindow
        cta={() => setWizardExpanded(true)}
        ctaText=''
        open={wizardTextOpen}
        setOpen={setWizardTextOpen}
      >
        {
          wizardExpanded
            ? (
              <div style={{ maxWidth: 350, padding: 20 }}>
                <img src={LongFMLogo} height={30} />
                <br />
                <br />
                <b>Gib' an, was du suchst und wir informieren dich, wenn wir einen passenden Arbeitgeber gefunden haben</b>
                <br />
                <br />
                Du brauchst dafür nur 1 Minute...
                <br />
                <br />
                <PrimaryButton
                  onClick={() => openWindow('wizard', {
                    mapInstance: mapInstance.map,
                    mapApi: mapInstance.api,
                    onClose: () => setMapFilterKey(old => old + 1)
                  })} style={{ maxWidth: 150, float: 'right' }} scale={1}
                >
                  Jetzt starten
                </PrimaryButton>
              </div>
              )
            : (
              <>Sollen wir für dich gute Arbeitgeber suchen?</>
              )
        }

      </MiniWindow>
      <div
        style={{ borderRadius: 12, backgroundColor: 'white', boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.2)', padding: '4px 12px', bottom: 12, right: 12, zIndex: 1100, position: 'fixed' }}
      >
        <table>
          <tr>
            <td>Nur Bewertete</td>
            {/* <td style={{ color: filter.rated ? 'yellow' : 'black' }}><i className='fa fa-star' /><i className='fa fa-star' /><i className='fa fa-star' /></td> */}
            <td style={{ paddingTop: 4 }}>&nbsp;&nbsp;<CheckField setValue={(v) => setFilter(old => ({ ...old, rated: v }))} value={filter.rated} /></td>
          </tr>
        </table>

      </div>
    </div>
  );
};

export default ClinicMap;
